// extracted by mini-css-extract-plugin
module.exports = {"column":"column-1_UbA3HX","tit":"tit-3OdHSSEE","column_pic":"column_pic-3Ipx_Vhc","intro_p":"intro_p-dUqvJD3Q"};